<template>
  <!--
    作者：gmshop
    时间：2020-06-25
    描述：插件中心-分红奖金池-分红详情
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="会员">
          <el-input size="small" style="width:150px" v-model="formInline.nickname" clearable placeholder="请输入会员昵称"></el-input>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="small" v-model="formInline.product_name" clearable placeholder="请输入商品名称"></el-input>
          </el-form-item>
        <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="user.nickName" label="会员"></el-table-column>
            <el-table-column prop="product.product_name" label="产品"></el-table-column>
            <el-table-column prop="bonus" label="金额"></el-table-column>
            <el-table-column prop="is_send" label="是否结算">
              <template slot-scope="scope">
                <span v-if="scope.row.is_send == 0">未结算</span>
                <span v-else>已结算</span>
              </template>
            </el-table-column>
            <el-table-column prop="send_time" label="结算时间" width="200"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="200"></el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
      <!--操作-->
      <div class="common-button-wrapper">
        <el-button size="small" @click="cancelFunc">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import BonusApi from '@/api/plus/bonus.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {},
      status: ['未开始', '进行中', '已结束'],
      bonus_date: '',
    };
  },
  created() {
    this.bonus_date = this.$route.query.bonus_date;
    /*获取列表*/
    this.getTableList();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.bonus_date = self.bonus_date;
      self.loading = true;
      BonusApi.detail(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*取消*/
    cancelFunc() {
      /*存储缓存*/
      localStorage.setItem('activeName','first')
      this.$router.back(-1);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/bonus/record/detail.vue